import { useEffect, useState } from "react";
import { useParams, Link } from "react-router";
import MenuCard from "../components/MenuCard"
import { Search, Star } from "lucide-react"
import { PROXY_SERVER, DELHI_LAT, DELHI_LNG } from "../utils/config";


export default function RestaurantMenu(){

    let {id} = useParams();
    const [selected, setSelected] = useState(null);
    const [restaurantInfo, setRestaurantInfo] = useState(null);
    const [RestData, setRestData] = useState(null);
    const [error, setError] = useState(false);

    useEffect(()=>{

        setRestData(null);
        setRestaurantInfo(null);
        setError(false);

        async function fetchData() {
            try {
               const swiggyAPI = `https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=${DELHI_LAT}&lng=${DELHI_LNG}&restaurantId=${id}`;
               const response = await fetch(PROXY_SERVER+swiggyAPI);
               const data = await response.json();
               const tempData = data?.data?.cards[5]?.groupedCard?.cardGroupMap?.REGULAR?.cards;
               if(Array.isArray(tempData)){
                   const filterData = tempData.filter((items)=> 'title' in items?.card?.card)
                   setRestaurantInfo(data?.data?.cards[2]?.card?.card?.info);
                   setRestData(filterData);
               } else {
                   setError(true);
               }
            } catch (err) {
                setError(true);
            }
        }

        fetchData();
       },[id])

    if(error){
        return (
            <div className="w-[80%] mx-auto mt-20 text-center">
                <p className="text-xl text-charcoal/60">Couldn't load this restaurant's menu right now. Please try again shortly.</p>
            </div>
        )
    }

    if(RestData === null){
        return (
            <div className="w-[80%] mx-auto mt-10 mb-20 animate-pulse">
                <div className="h-40 bg-charcoal/10 rounded-2xl mb-8"></div>
                <div className="h-16 w-full bg-charcoal/10 rounded-2xl mb-8"></div>
                <div className="h-6 w-40 bg-charcoal/10 rounded mb-10"></div>
                <div className="h-6 w-3/4 bg-charcoal/10 rounded mb-4"></div>
                <div className="h-6 w-2/3 bg-charcoal/10 rounded"></div>
            </div>
        )
    }

    return(
        <div>

        <div className="w-[80%] mx-auto mt-10 mb-6">
            <Link to="/restaurant" className="text-charcoal/60 hover:text-charcoal text-sm">&larr; Back to restaurants</Link>
        </div>

        {
            restaurantInfo &&
            <div className="w-[80%] mx-auto mb-10 pb-8 border-b border-charcoal/15">
                <div className="flex items-center justify-between flex-wrap gap-2">
                    <h1 className="font-display text-4xl font-semibold text-charcoal">{restaurantInfo.name}</h1>
                    {
                        restaurantInfo.availability?.opened === false &&
                        <span className="text-ember font-medium border border-ember rounded-full px-4 py-1 text-sm">Closed now</span>
                    }
                </div>
                <div className="flex flex-wrap items-center gap-3 mt-3 text-charcoal/70">
                    <span className="flex items-center gap-1 font-mono">
                        <Star className="w-4 h-4 text-curry" fill="currentColor" />
                        {restaurantInfo.avgRatingString} ({restaurantInfo.totalRatingsString})
                    </span>
                    <span className="text-charcoal/30">•</span>
                    <span className="font-mono">{restaurantInfo.sla?.slaString}</span>
                    <span className="text-charcoal/30">•</span>
                    <span className="font-mono">{restaurantInfo.costForTwoMessage}</span>
                </div>
                <p className="text-charcoal/60 mt-2">{restaurantInfo.cuisines?.join(", ")}</p>
                <p className="text-charcoal/50 text-sm mt-1">{restaurantInfo.areaName}, {restaurantInfo.city}</p>
            </div>
        }

        <div className="w-[80%] mx-auto mb-16">
          <Link to={`/city/delhi/${id}/search`} className="relative flex items-center py-4 pl-14 pr-6 rounded-2xl bg-cream border border-charcoal/15 shadow-sm hover:border-turmeric hover:shadow-md transition">
            <Search className="w-5 h-5 text-charcoal/40 absolute left-6 top-1/2 -translate-y-1/2" />
            <span className="text-xl text-charcoal/50">Search for dishes</span>
          </Link>
        </div>

        <div className="w-[80%] mx-auto mb-16">
        <button className={`text-xl py-2 px-8 mr-4 border rounded-2xl transition ${selected==="veg"? "bg-curry text-cream border-curry": "bg-transparent text-charcoal/70 border-charcoal/20"} `} onClick={()=>setSelected(selected==='veg'?null:'veg')}>Veg</button>
        <button className={`text-xl py-2 px-4 border rounded-2xl transition ${selected==="nonveg"? "bg-ember text-cream border-ember": "bg-transparent text-charcoal/70 border-charcoal/20"}`} onClick={()=>setSelected(selected==='nonveg'?null:'nonveg')}>Non veg</button>
        </div>

        <div className="w-[80%] mx-auto mb-20">
          {
            RestData.map((menuItems)=><MenuCard key={menuItems?.card?.card?.title} menuItems={menuItems?.card?.card} foodselected={selected}></MenuCard>)
          }
        </div>
        </div>
    )

}